/*
 * File: index.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 2, 2025 at 10:06 AM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: April 19, 2025 at 11:55 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Utilities
import { api } from '../api';

// Constants
const { PARSE_MOUNT } = process.env;


/**
 * Services
 */

export const fetchStoryTags = ({ page } = {}) => api.post(`${PARSE_MOUNT}/functions/fetchStoryTagsWithParameters`, { page });

export const fetchQuestionTags = ({ page, limitToUsage } = {}) => api.post(`${PARSE_MOUNT}/functions/fetchQuestionTagsWithParameters`, { page, limit_to_usage: limitToUsage });

export const suggestTag = ({
	suggestion,
	recaptchaToken,
} = {}) => api.post(`${PARSE_MOUNT}/functions/suggestTagWithParameters`, {
	suggestion,
	recaptcha_token: recaptchaToken,
});
